/** @format */
import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

export async function updateStatusDocuments(
  currentstatus,
  newstatus,
  docList,
  token
) {
  const apiUrl = `${apiURL}/admin/document/massupdate`;

  const parsedDocList = JSON.parse(docList);

  const fetchbody = JSON.stringify({
    "CurrentStatus": currentstatus,
    "NewStatus": newstatus,
    "DocList": parsedDocList
  });

  return await apiRequest(apiUrl, {
    method: "PATCH",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: fetchbody
  });
}